
<v-app id="app" class="app-body" style="position:relative;">
    <v-overlay :value="loading" absolute opacity="0"></v-overlay>

    <v-snackbar
        v-model  = "showMessage"
        :color   = "color"
        :timeout = "timeout"
        class    = "stored"
    >
        {{ message }}

        <template v-slot:action="{ attrs }">
            <a
                v-if   = "closeSnackbar"
                v-bind = "attrs"
                @click = "showMessage = false"
            >
                <v-icon>mdi-close</v-icon>
            </a>
        </template>
    </v-snackbar>

    <d-app-message
        v-model  = "showMessageDialog"
        :message = "messageRessource"
    />

    <d-app-confirm
        v-model  = "confirm.show"
        :text    = "confirm.query"
        :subtext = "confirm.text"
        :width   = "confirm.width"
        :spinner = "confirm.spinner"
        @confirm = "onConfirmX"
    />

    <c-dms-dragable-viewer

    />

    <div class="loading-bar" v-if="loading" style="z-index: 500">
        <div class="mb-1 primary--text">
            {{ loadingMessage ? loadingMessage : $t('common.loading') }}
        </div>
        <v-progress-linear
            indeterminate
            color="primary"
            height="10"
        ></v-progress-linear>
    </div>

    <c-app-memory
        v-if  = "showMemoryGadget"
        class = "memory-info"
    />

    <router-view style="margin-top: 2px;" v-if="initialized"></router-view>
</v-app>
